import { applyMiddleware, createStore } from 'redux';
import createRootReducer from './reducer';
import { promiseMiddleware, localStorageMiddleware } from './middleware';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};

/**
 * Persist reducer for redux
 * @type {Reducer<((state: (CombinedState<unknown> | undefined), action: AnyAction) => CombinedState<unknown>) & PersistPartial, Action>}
 */
const persistedReducer = persistReducer(persistConfig, createRootReducer);

export const history = createBrowserHistory({
  basename: process.env.REACT_APP_SUB_DIR,
});

/**
 * Add middlewares
 * @returns {StoreEnhancer<{dispatch: unknown}>}
 */
const getMiddleware = () => {
  if (process.env.NODE_ENV === 'production') {
    return applyMiddleware(
      routerMiddleware(history),
      promiseMiddleware,
      localStorageMiddleware,
      thunk
    );
  } else {
    // Enable additional logging in non-production environments.
    return applyMiddleware(
      routerMiddleware(history),
      promiseMiddleware,
      localStorageMiddleware,
      thunk
    );
  }
};

/**
 * Create the redux store
 * @type {Store<CombinedState<unknown>, AnyAction> & R}
 */
export const store = createStore(
  createRootReducer(history, persistedReducer),
  composeWithDevTools(getMiddleware())
);
